'use client';

import { BasicProductDataResponse } from '@/src/types/catalog';
import { ProductCard } from '../../stores/[store]/[storeId]/product/components/ProductCard';
import { useTranslations } from 'next-intl';

import SearchConatiner from './SearchConatiner';
import { useCountryStore } from '@/src/lib/state-stores/currencyStore';
import { TCountryId } from '@/src/components/sarComponent';

export const SearchComponent = ({
  data,
  query,

  title,
  smallHeading,
}: {
  data: BasicProductDataResponse[];
  query?: string;

  title?: string;
  smallHeading?: string;
}) => {
  const t = useTranslations('search');
  const { countryId } = useCountryStore();

  return (
    <SearchConatiner
      title={title ?? t('Search Result for')}
      subtitle={query}
      length={data.length}
      smallHeading={smallHeading}
    >
      {/* products */}
      <div className="mx-auto grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-5 lg:grid-cols-5 lg:gap-4">
        {data.map((ele, index) => {
          if (isNaN(Number(ele.branchId))) return null;
          return (
            <div key={index}>
              <ProductCard
                productDetails={ele}
                isSearchPage
                branchCountryId={Number(countryId) as TCountryId}
              />
            </div>
          );
        })}
      </div>
    </SearchConatiner>
  );
};
